<template>
  <div>
    <div class="index">
      <div class="index_top clearfix">
        <div class="index_Tleft fl" @click="DeptMng()">
          <span class="fl logo_img">
            <img
              :src="
                deptLogo.length > 0
                  ? deptLogo
                  : require('../assets/img/logo.png')
              "
              alt=""
            />
          </span>
          <span class="fl logo_text">{{ deptName }}</span>
        </div>
        <div class="index_Tright fr">
          <el-dropdown
            @command="PageJump"
            trigger="hover"
            v-for="(item, index) in institutionsTree"
            :key="index"
          >
            <div class="index_text">{{ item.menuName }}</div>
            <el-dropdown-menu
              slot="dropdown"
              v-if="item.list.length == 0 ? false : true"
            >
              <el-dropdown-item
                :command="index + '/' + i"
                v-for="(val, i) in item.list"
                :key="i"
                >{{ val.menuName }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div class="index_content clearfix">
        <div class="index_content_list">
          <div class="content_list">
            <div class="index_rbox_list" id="onlineCharts"></div>
          </div>
          <div class="content_list">
            <div class="index_rbox_list" id="policeCharts"></div>
          </div>
          <div class="content_list">
            <div class="index_rbox_list" id="callPoliceCharts"></div>
          </div>
        </div>
        <div class="index_content_box">
          <div class="content_top">
            <img
              :src="
                deptPhoto.length > 0
                  ? deptPhoto
                  : require('../assets/img/bgs.png')
              "
              alt=""
            />
          </div>
          <!-- 报警类型统计 -->
          <div class="content_btn">
            <div class="index_rbox_list" id="typeCharts"></div>
          </div>
        </div>
        <div class="index_content_list">
          <div class="content_list_tab">
            <div class="baoj">
              <h1>实时报警信息</h1>
              <div class="baoj_title clearfix">
                <span class="fl">设备名称</span>
                <span class="fl">报警内容</span>
                <span class="fl">报警时间</span>
              </div>
              <div
                v-show="HJ212RecordsList.length > 0"
                class="baoj_list clearfix"
                v-for="(item, index) in HJ212RecordsList"
                :key="index"
              >
                <span class="fl" :title="item.deviceName">{{
                  item.deviceName
                }}</span>
                <span class="fl"
                  >{{ item.data_desc }}的值{{
                    item.logFlag > 0 ? "高" : "低"
                  }}于{{
                    item.logFlag > 0 ? item.maxValue : item.minValue
                  }}</span
                >
                <span class="fl" :title="item.logDate + ' ' + item.logTime"
                  >{{ item.logDate }} {{ item.logTime }}</span
                >
              </div>
              <div v-show="HJ212RecordsList.length == 0">
                <el-empty description="暂无数据"></el-empty>
              </div>
            </div>
          </div>
          <!-- <div class="content_list" v-show="false">
            <div class="index_rbox_list" id="groupingCharts"></div>
          </div> -->
        </div>
      </div>
    </div>

    <!-- 更换LOGO/主图 -->
    <!-- <div class="logo_box" v-show="true"> -->
    <div class="logo_box" v-show="logoHis">
      <div class="logo_content">
        <div class="down">
          <i class="el-icon-close" @click="logoHis = false" title="关闭"></i>
        </div>
        <template>
          <el-tabs tab-position="left" style="height: 100%">
            <el-tab-pane label="修改基础信息" v-if="isQxian">
              <h1>修改基础信息</h1>
              <div class="user_box clearfix">
                <div class="box">
                  <div class="user_list">
                    <div class="user_box_list clearfix">
                      <span class="fl">归属机构：</span>
                      <p class="fl">{{ parentName }}</p>
                    </div>
                    <div class="user_box_list clearfix">
                      <span class="fl">机构名称：</span>
                      <div class="fl">
                        <el-input
                          v-model="form.deptName"
                          placeholder="请输入内容"
                        ></el-input>
                      </div>
                    </div>
                    <div class="user_box_list clearfix">
                      <span class="fl">联系人：</span>
                      <div class="fl">
                        <el-input
                          v-model="form.contactor"
                          placeholder="请输入内容"
                        ></el-input>
                      </div>
                    </div>
                    <div class="user_box_list clearfix">
                      <span class="fl">联系电话：</span>
                      <div class="fl">
                        <el-input
                          v-model="form.phone"
                          placeholder="请输入内容"
                        ></el-input>
                      </div>
                    </div>
                    <div class="user_box_list clearfix">
                      <span class="fl">地址：</span>
                      <div class="fl">
                        <el-input
                          v-model="form.address"
                          placeholder="请输入内容"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="user_list">
                    <div class="user_box_list clearfix">
                      <span class="fl">机构ID：</span>
                      <p class="fl">{{ form.deptId }}</p>
                    </div>
                    <div class="user_box_list clearfix">
                      <span class="fl">小数点精确位数：</span>
                      <div class="fl">
                        <el-input
                          v-model="form.postalcode"
                          placeholder="请输入内容"
                        ></el-input>
                      </div>
                    </div>
                    <div class="user_box_list clearfix">
                      <span class="fl">电子邮箱：</span>
                      <div class="fl">
                        <el-input
                          v-model="form.email"
                          placeholder="请输入内容"
                        ></el-input>
                      </div>
                    </div>
                    <div class="user_box_list clearfix">
                      <span class="fl">IP地址：</span>
                      <div class="fl">
                        <el-input
                          v-model="form.ipAddress"
                          placeholder="请输入内容"
                        ></el-input>
                      </div>
                    </div>
                    <div class="user_box_list clearfix">
                      <span class="fl">备注：</span>
                      <div class="fl">
                        <el-input
                          type="textarea"
                          placeholder="请输入内容"
                          v-model="form.remark"
                          clearable
                        >
                        </el-input>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="user_btn">
                  <el-button type="primary" @click="DeptMngClick()"
                    >提交修改</el-button
                  >
                </div>

                <div class="user_image">
                  <h3>
                    修改LOGO/中心主图后，重新登录，可能还要手动清一下浏览器缓存再刷新一下页面才有效
                  </h3>
                  <h2>LOGO</h2>
                  <div class="user_img1">
                    <img
                      class="image1"
                      :src="
                        deptLogo.length > 0
                          ? deptLogo
                          : require('../assets/img/logo.png')
                      "
                      alt=""
                    />
                    <input
                      class="input1"
                      type="file"
                      accept="image/jpeg,image/png,image/gif"
                      @change="getFile"
                    />
                  </div>
                  <h2>中心主图</h2>
                  <div class="user_img2">
                    <img
                      class="image2"
                      :src="
                        deptPhoto.length > 0
                          ? deptPhoto
                          : require('../assets/img/bgs.png')
                      "
                      alt=""
                    />
                    <input
                      class="input2"
                      type="file"
                      @change="deptPhotoClick"
                      accept="image/jpeg,image/png,image/gif"
                    />
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <!-- <el-tab-pane label="上传LOGO">
              <h1>上传LOGO</h1>
              <div class="logo_boxs">
                <img
                  :src="
                    deptLogo.length > 0
                      ? deptLogo
                      : require('../assets/img/logo.png')
                  "
                  alt=""
                />
                <i class="el-icon-upload">
                  <input
                    type="file"
                    accept="image/jpeg,image/png,image/gif"
                    @change="getFile"
                  />
                </i>
              </div>
            </el-tab-pane>
            <el-tab-pane label="上传中心主图">
              <h1>上传中心主图</h1>
              <div class="deptPhoto">
                <img
                  :src="
                    deptPhoto.length > 0
                      ? deptPhoto
                      : require('../assets/img/bjs.webp')
                  "
                  alt=""
                />
                <input
                  type="file"
                  @change="deptPhotoClick"
                  accept="image/jpeg,image/png,image/gif"
                />
              </div>
            </el-tab-pane> -->
            <el-tab-pane label="修改密码">
              <h1>修改密码</h1>
              <div class="password">
                <div class="password_tab clearfix">
                  <span class="fl">旧密码：</span>
                  <div class="fl">
                    <el-input
                      placeholder="请输入旧密码"
                      v-model="pwdModify.oldPwd"
                      clearable
                      show-password
                    >
                    </el-input>
                  </div>
                </div>
                <div class="password_tab clearfix">
                  <span class="fl">新密码：</span>
                  <div class="fl">
                    <el-input
                      placeholder="请输入新密码"
                      v-model="pwdModify.newPwd"
                      clearable
                      show-password
                    >
                    </el-input>
                  </div>
                </div>
                <div class="password_tab clearfix">
                  <span class="fl">确认新密码：</span>
                  <div class="fl">
                    <el-input
                      placeholder="请确认新密码"
                      v-model="pwdModify.confirm"
                      clearable
                      show-password
                    >
                    </el-input>
                  </div>
                </div>
                <div class="password_text">
                  密码长度最短8位；必须同时包含数字、大写字母、小写字母。
                </div>
                <div class="password_btn">
                  <el-button type="primary" @click="pwdModifyClick()"
                    >提交修改</el-button
                  >
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="切换账号">
              <h1>切换账号</h1>
              <div class="switch_account">
                <div class="">
                  <i class="el-icon-s-custom"></i>
                  <!-- <img src="" alt="" /> -->
                  <p>{{ deptName }}</p>
                  <!-- <p>{{ userName }}</p> -->
                  <el-button type="primary" @click="logout()"
                    >切换账号</el-button
                  >
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 无访问权限
      isQxian: true,
      // 监听窗口变化
      screenWidth: document.body.clientWidth,
      // 用户ID
      deptId: "",
      loginToken: "",
      // 更换LOGO显示隐藏
      logoHis: false,
      // LOGO相对路径
      deptPhotoPath: "",
      // logo
      deptLogo: "",
      // 中心主图
      deptPhoto: "",
      imageUrl: "",
      // 角色名称
      userName: "角色名称",
      // 用户名称
      deptName: "用户名称",
      // Tab菜单结构
      institutionsTree: [],

      // 修改密码LIST
      pwdModify: {
        oldPwd: "", //旧密码
        newPwd: "", //新密码
        confirm: "", //确认新密码
      },

      // 实时报警信息
      HJ212RecordsList: [],

      // 设备状态统计
      stat: {},

      // 最近7天日期
      dateArray: [],
      // 最近7天报警统计
      policeList: {
        normal: ["", "", "", "", "", "", ""],
        lowAlarm: ["", "", "", "", "", "", ""],
        highAlarm: ["", "", "", "", "", "", ""],
      },

      input: "",
      // 上级机构名称
      parentName: "上级机构",
      // 修改基本信息
      form: {
        deptId: "", //机构ID（该值标识为哪个机构，其本身不能被修改）
        deptName: "", //机构名称
        status: 1, //启用状态，0停用，1启用。（固定填1，该项作为预留参数）
        contactor: "", //联系人
        phone: "", //联系电话
        address: "", //地址
        postalcode: "", //小数点精确位数
        email: "", //电子邮箱
        ipAddress: "", //IP地址
        remark: "", //备注
      },
    };
  },
  watch: {
    screenWidth(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val;
        this.timer = true;
        let that = this;
        setTimeout(function () {
          // 打印screenWidth变化的值
          // console.log(that.screenWidth);

          // 设备在线状态统计
          that.onlineCharts(0, 0, 0, 0);
          // 设备报警统计
          that.policeCharts(0, 0);
          // 报警状态统计
          that.callPoliceCharts(0, 0);
          // 各分组报警统计
          // that.groupingCharts();
          // 报警类型统计
          that.typeCharts(that.policeList);
          that.timer = false;
        }, 1000);
      }
    },
  },
  created() {
    this.deptId = localStorage.getItem("deptId");
    this.loginToken = localStorage.getItem("loginToken");

    let deptLogo = localStorage.getItem("deptLogo");
    let deptPhoto = localStorage.getItem("deptPhoto");
    // 获取LOGO相对路径
    this.deptPhotoPath = this.logoUrl + localStorage.getItem("deptPhotoPath");
    if (deptLogo !== "" && deptLogo !== null) {
      this.deptLogo = this.deptPhotoPath + deptLogo;
    }
    if (deptPhoto !== "" && deptPhoto !== null) {
      this.deptPhoto = this.deptPhotoPath + deptPhoto;
    }
    // console.log(this.deptPhotoPath,this.deptLogo)
    // Tab菜单结构
    this.institutionsTree = JSON.parse(
      localStorage.getItem("institutionsTree")
    );
    // console.log(this.institutionsTree)
    // this.institutionsTree = JSON.parse(institutionsTree);
    // 获取用户名称
    // this.userName = localStorage.getItem("userName");
    this.deptName = localStorage.getItem("deptName");

    // 获取机构树
    this.pubAction();
    // 获取采集点的报警数据
    this.RecordsLists();
    // 设备状态统计
    this.HJ212Stats();
    // 获取最近7天日期
    this.dateTime();

    this.fn();
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
    // 设备在线状态统计
    this.onlineCharts(0, 0, 0, 0);
    // 设备报警统计
    this.policeCharts(0, 0);
    // 报警状态统计
    this.callPoliceCharts(0, 0);
    // 各分组报警统计
    // this.groupingCharts();
    // 报警类型统计
    this.typeCharts(this.policeList);
  },
  methods: {
    fn() {
      // 获取loginToken
      let loginToken = localStorage.getItem("loginToken");
      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "PubAction", //交易码
          option: "DeptTree",
          deptId: "", //归属机构ID
          loginToken,
        },
      })
        .then((res) => {
          if (res.data._STATUS == "0") {
            let mapTree = JSON.stringify(res.data.map);

            localStorage.setItem("mapTree", mapTree);
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 提交修改机构
    DeptMngClick() {
      if (this.form.deptName == "") {
        this.$message({
          message: "机构名称不能为空!",
          type: "warning",
        });
      } else {
        // 获取loginToken,deptId
        let loginToken = localStorage.getItem("loginToken");

        this.$axios({
          method: "post",
          url: this.api,
          data: {
            txcode: "DeptMng", //交易码
            option: "MODI", //交易选项
            deptId: this.form.deptId, //机构ID（该值标识为哪个机构，其本身不能被修改）
            deptName: this.form.deptName, //机构名称
            status: this.form.status, //启用状态，0停用，1启用。（固定填1，该项作为预留参数）
            contactor: this.form.contactor, //联系人
            phone: this.form.phone, //联系电话
            address: this.form.address, //地址
            postalcode: this.form.postalcode, //小数点精确位数
            email: this.form.email, //电子邮箱
            ipAddress: this.form.ipAddress, //IP地址
            remark: this.form.remark, //备注
            loginToken,
          },
        })
          .then((res) => {
            console.log(res, "---");
            if (res.data._STATUS == 0) {
              this.deptName = res.data.deptName;
              this.$message({
                type: "success",
                message: "修改成功！",
              });
            } else {
              this.loginTimeout();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    // 机构管理明细
    DeptMng() {
      this.logoHis = true;
      // 获取loginToken,deptId
      let loginToken = localStorage.getItem("loginToken");
      let deptId = localStorage.getItem("deptId");

      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "DeptMng", //交易码
          option: "VIEW", //交易选项，或填EDIT
          deptId, //机构ID
          loginToken,
        },
      })
        .then((res) => {
          console.log(res);
          if (res.data._ERROR == "无访问权限") {
            this.isQxian = false;
            return;
          }
          if (res.data._STATUS == 0) {
            this.parentName = res.data.parentName;

            this.form = res.data.map;
          } else {
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 退出登录
    logout() {
      // 获取loginToken
      let loginToken = localStorage.getItem("loginToken");

      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "Logout",
          loginToken,
        },
      })
        .then((res) => {
          console.log(res);
          if (res.data._STATUS == "0") {
            // 清楚loginToken本地存储
            window.localStorage.removeItem("loginToken");
            // window.localStorage.clear();
            // 退出登录后跳转
            this.$router.push("/login");
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    logoPhoto(num) {
      // 获取loginToken,deptId
      let loginToken = localStorage.getItem("loginToken");
      let deptId = localStorage.getItem("deptId");

      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "DeptMng", //交易码
          option: "VIEW", //交易选项，或填EDIT
          deptId, //机构ID
          loginToken,
        },
      })
        .then((res) => {
          console.log(res);
          if (res.data._STATUS == 0) {
            if (num == 1) {
              // logo
              if (res.data.deptLogo !== "") {
                // 获取LOGO相对路径
                this.deptPhotoPath =
                  this.logoUrl + localStorage.getItem("deptPhotoPath");
                this.deptLogo = this.deptPhotoPath + res.data.deptLogo;
                this.$message({
                  type: "success",
                  message: "上传成功！",
                });
              } else {
                this.$message({
                  message: "上传失败或无权限上传!",
                  type: "warning",
                });
                this.deptLogo = "";
              }
            }
            if (num == 2) {
              // 中心主图
              if (res.data.deptPhoto !== "") {
                // 获取中心主图相对路径
                this.deptPhotoPath =
                  this.logoUrl + localStorage.getItem("deptPhotoPath");

                this.deptPhoto = this.deptPhotoPath + res.data.deptPhoto;
                // console.log(this.deptPhoto);

                // console.log(this.deptPhoto);
                this.$message({
                  type: "success",
                  message: "上传成功！",
                });
              } else {
                this.$message({
                  message: "上传失败或无权限上传!",
                  type: "warning",
                });
                this.deptPhoto = "";
              }
            }
          } else {
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 上传LOGO
    getFile(e) {
      let deptId = localStorage.getItem("deptId");
      let loginToken = localStorage.getItem("loginToken");
      let file = e.target.files[0];

      if (file.size / 1024 > 2048) {
        this.$message({
          message: "图片大小超过2M,上传失败!",
          type: "warning",
        });
        return;
      }
      if (file.size / 1024 <= 0) {
        this.$message({
          message: "图片大小异常，请重新上传!",
          type: "warning",
        });
        return;
      }

      //创建form对象
      let param = new FormData();
      //通过append向form对象添加数据
      param.append("txcode", "DeptMng");
      param.append("option", "AddLogo");
      param.append("deptId", deptId);
      param.append("nametype", "SYSTEM");
      param.append("upload", file);
      param.append("loginToken", loginToken);
      //FormData私有类对象，通过get判断值是否传进去
      // console.log(param.get("upload"));

      this.$axios({
        method: "post",
        url: this.api + "?_uploadid=" + file.lastModified,
        data: param,
        config: {
          headers: { "Content-Type": "multipart/form-data" },
        },
      })
        .then((res) => {
          console.log(res, "上传LOGO");
          if (res.data._ERROR == "无访问权限") {
            this.$message({
              message: "无上传权限!",
              type: "warning",
            });
            return;
          }
          // console.log(res);
          if (res.data._STATUS == "0") {
            // this.logoPhoto("1");
            // 获取LOGO相对路径
            this.deptPhotoPath =
              this.logoUrl + localStorage.getItem("deptPhotoPath");
            this.deptLogo = this.deptPhotoPath + res.data.imgName;
            console.log(this.deptLogo);
            this.$message({
              type: "success",
              message: "上传成功！",
            });
          } else {
            // 登录超时调用
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 上传中心主图
    deptPhotoClick(e) {
      let deptId = localStorage.getItem("deptId");
      let loginToken = localStorage.getItem("loginToken");
      let file = e.target.files[0];

      if (file.size / 1024 > 2048) {
        this.$message({
          message: "图片大小超过2M,上传失败!",
          type: "warning",
        });
        return;
      }
      if (file.size / 1024 <= 0) {
        this.$message({
          message: "图片大小异常，请重新上传!",
          type: "warning",
        });
        return;
      }

      //创建form对象
      let param = new FormData();
      //通过append向form对象添加数据
      param.append("txcode", "DeptMng");
      param.append("option", "AddPhoto");
      param.append("deptId", deptId);
      param.append("nametype", "SYSTEM");
      param.append("upload", file);
      param.append("loginToken", loginToken);
      //FormData私有类对象，通过get判断值是否传进去
      // console.log(param.get("upload"));

      this.$axios({
        method: "post",
        url: this.api + "?_uploadid=" + file.lastModified,
        data: param,
        config: {
          headers: { "Content-Type": "multipart/form-data" },
        },
      })
        .then((res) => {
          if (res.data._ERROR == "无访问权限") {
            this.$message({
              message: "无上传权限!",
              type: "warning",
            });
            return;
          }
          console.log(res);
          if (res.data._STATUS == "0") {
            // this.logoPhoto("2");
            // 获取中心主图相对路径
            this.deptPhotoPath =
              this.logoUrl + localStorage.getItem("deptPhotoPath");
            this.deptPhoto = this.deptPhotoPath + res.data.imgName;
            console.log(this.deptPhoto);
            // console.log(this.deptPhoto);
            this.$message({
              type: "success",
              message: "上传成功！",
            });
          } else {
            // 登录超时调用
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 7天报警统计
    policeStatistics(index) {
      let loginToken = localStorage.getItem("loginToken");
      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "HJ212Alarm", //交易码
          option: "LIST", //交易选项，不填则返回设备列表，填DOWNLOAD表示导出数据文件。
          deviceId: "", //设备ID
          logFlag: "", //警报状态，-1过低、0正常、1超高。
          dataName: "", //数据键
          dataDesc: "", //数据项
          beginDate: this.dateArray[index], //记录日期区间开始日
          endDate: this.dateArray[index], //记录日期区间结束日
          page: 1, //当前页码
          pageSize: "500", //每页记录数
          loginToken,
        },
      })
        .then((res) => {
          if (res.data._STATUS == 0) {
            var lowAlarm = 0;
            var normal = 0;
            var highAlarm = 0;
            if (res.data.list.length > 0) {
              for (let i = 0; i < res.data.list.length; i++) {
                if (res.data.list[i].logFlag == "-1") {
                  lowAlarm += 1;
                }
                if (res.data.list[i].logFlag == "0") {
                  normal += 1;
                }
                if (res.data.list[i].logFlag == "1") {
                  highAlarm += 1;
                }
              }
            }
            this.policeList.lowAlarm[index] = lowAlarm;
            this.policeList.normal[index] = normal;
            this.policeList.highAlarm[index] = highAlarm;

            if (index == 6) {
              var _this = this;
              setTimeout(() => {
                _this.typeCharts(_this.policeList);
              }, 1000);
            }
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取最近7天日期
    dateTime() {
      //设置日期，当前日期的前七天
      var myDate = new Date(); //获取今天日期
      myDate.setDate(myDate.getDate() - 6);
      var dateArray = [];
      var dateTemp;
      var flag = 1;
      var _this = this;
      for (var i = 0; i < 7; i++) {
        let y = myDate.getMonth() + 1;
        let r = myDate.getDate();
        dateTemp =
          myDate.getFullYear() +
          "-" +
          (y > 9 ? y : "0" + y) +
          "-" +
          (r > 9 ? r : "0" + r);
        dateArray.push(dateTemp);
        myDate.setDate(myDate.getDate() + flag);
      }

      this.dateArray = dateArray;

      for (let i = 0; i < 7; i++) {
        ((i) => {
          _this.policeStatistics(i);
        })(i);
      }
    },
    // 设备状态统计
    HJ212Stats() {
      // 获取loginToken
      let loginToken = localStorage.getItem("loginToken");

      this.$axios({
        method: "post",
        url: this.api,
        data: { txcode: " HJ212Stat", loginToken },
      })
        .then((res) => {
          // 登录超时
          if (res.data._STATUS == "0") {
            this.stat = res.data.stat;

            let totalCount = res.data.stat.totalCount;
            let onlineCount = res.data.stat.onlineCount;
            let offlineCount = res.data.stat.offlineCount;

            let lv = parseInt((onlineCount / totalCount) * 100) + "%";
            this.onlineCharts(totalCount, onlineCount, offlineCount, lv);

            let normalCount = res.data.stat.normalCount;
            let warningCount = res.data.stat.warningCount;

            // 报警状态统计图表
            this.callPoliceCharts(normalCount, warningCount);
          } else {
            // 登录超时调用
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 获取采集点的报警数据
    RecordsLists() {
      let time = new Date();
      let n = time.getFullYear();
      let y =
        time.getMonth() + 1 > 9
          ? time.getMonth() + 1
          : "0" + (time.getMonth() + 1);
      let r = time.getDate() > 9 ? time.getDate() : "0" + time.getDate();

      let beginDate = n + "-" + y + "-" + r;
      let endDate = n + "-" + y + "-" + r;

      let loginToken = localStorage.getItem("loginToken");
      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "HJ212Alarm", //交易码
          option: "LIST", //交易选项，不填则返回设备列表，填DOWNLOAD表示导出数据文件。
          deviceId: "", //设备ID
          logFlag: "", //警报状态，-1过低、0正常、1超高。
          dataName: "", //数据键
          dataDesc: "", //数据项
          beginDate: beginDate, //记录日期区间开始日
          endDate: endDate, //记录日期区间结束日
          page: 1, //当前页码
          pageSize: "100", //每页记录数
          loginToken,
        },
      })
        .then((res) => {
          if (res.data._STATUS == 0) {
            if (res.data.list.length > 0) {
              let list = [];
              for (let i = 0; i < res.data.list.length; i++) {
                if (res.data.list[i].logFlag == 0) {
                } else {
                  list.push(res.data.list[i]);
                }
              }
              this.HJ212RecordsList = list;

              let highAlarm = [];
              let lowAlarm = [];
              for (let i = 0; i < res.data.list.length; i++) {
                if (res.data.list[i].logFlag > 0) {
                  highAlarm.push(res.data.list[i]);
                }
                if (res.data.list[i].logFlag < 0) {
                  lowAlarm.push(res.data.list[i]);
                }
              }
              // 设备报警统计图表
              this.policeCharts(highAlarm.length, lowAlarm.length);
            } else {
              this.HJ212RecordsList = [];
            }
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 修改密码
    pwdModifyClick() {
      if (this.pwdModify.oldPwd == "") {
        this.$message({
          message: "旧密码不能为空!",
          type: "warning",
        });
        return;
      }
      if (this.pwdModify.newPwd == "") {
        this.$message({
          message: "新密码不能为空!",
          type: "warning",
        });
        return;
      }
      if (this.pwdModify.confirm == "") {
        this.$message({
          message: "确认新密码不能为空!",
          type: "warning",
        });
        return;
      }

      let loginToken = localStorage.getItem("loginToken");
      let deptId = localStorage.getItem("deptId");
      let userName = localStorage.getItem("userName");
      let deptName = localStorage.getItem("deptName");
      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "PwdModify", //交易码
          option: "MODI", //交易选项
          oldPwd: this.pwdModify.oldPwd, //旧密码
          newPwd: this.pwdModify.newPwd, //新密码
          confirm: this.pwdModify.confirm, //再次输入新密码
          loginToken,
        },
      })
        .then((res) => {
          if (res.data._STATUS == "0") {
            if (res.data._MESSAGE == "修改成功") {
              this.$message({
                type: "success",
                message: "修改成功",
              });
              this.$router.push("/login");
            } else {
              this.$message({
                message: res.data._ERROR,
                type: "warning",
              });
            }
          } else {
            // 登录超时调用
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 获取机构树
    pubAction() {
      // 获取loginToken
      let loginToken = localStorage.getItem("loginToken");
      let deptId = localStorage.getItem("deptId");

      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "PubAction",
          option: "DeptTree",
          deptId,
          loginToken,
        },
      })
        .then((res) => {
          if (res.data._STATUS == "0") {
            if (res.data.list.length > 0) {
              let list = res.data.list;

              let institutions = JSON.stringify(list);
              // 存储处理前机构
              localStorage.setItem("institutions", institutions);

              // 机构分层
              let layer1 = [];
              let layer2 = [];
              let layer3 = [];
              let layer4 = [];

              for (let i = 0; i < list.length; i++) {
                if (list[i].level == 1) {
                  let arr = {
                    value: list[i].deptId,
                    label: list[i].deptName,
                    parentId: list[i].parentId,
                    level: list[i].level,
                    children: [],
                  };
                  layer1.push(arr);
                }
                if (list[i].level == 2) {
                  let arr = {
                    value: list[i].deptId,
                    label: list[i].deptName,
                    parentId: list[i].parentId,
                    level: list[i].level,
                    children: [],
                  };
                  layer2.push(arr);
                }
                if (list[i].level == 3) {
                  let arr = {
                    value: list[i].deptId,
                    label: list[i].deptName,
                    parentId: list[i].parentId,
                    level: list[i].level,
                    children: [],
                  };
                  layer3.push(arr);
                }
                if (list[i].level == 4) {
                  let arr = {
                    value: list[i].deptId,
                    label: list[i].deptName,
                    parentId: list[i].parentId,
                    level: list[i].level,
                  };
                  layer4.push(arr);
                }
              }

              // 合并分层 3-4
              for (let i = 0; i < layer4.length; i++) {
                for (let j = 0; j < layer3.length; j++) {
                  (function (i, j) {
                    if (layer4[i].parentId == layer3[j].value) {
                      layer3[j].children.push(layer4[i]);
                    }
                  })(i, j);
                }
              }

              for (let i = 0; i < layer3.length; i++) {
                if (layer3[i].children.length == 0) {
                  delete layer3[i].children;
                }
              }

              // 合并分层 2-3
              for (let i = 0; i < layer3.length; i++) {
                for (let j = 0; j < layer2.length; j++) {
                  (function (i, j) {
                    if (layer3[i].parentId == layer2[j].value) {
                      layer2[j].children.push(layer3[i]);
                    }
                  })(i, j);
                }
              }

              for (let i = 0; i < layer2.length; i++) {
                if (layer2[i].children.length == 0) {
                  delete layer2[i].children;
                }
              }

              // 合并分层 1-2
              for (let i = 0; i < layer2.length; i++) {
                for (let j = 0; j < layer1.length; j++) {
                  (function (i, j) {
                    if (layer2[i].parentId == layer1[j].value) {
                      layer1[j].children.push(layer2[i]);
                    }
                  })(i, j);
                }
              }

              for (let i = 0; i < layer1.length; i++) {
                if (layer1[i].children.length == 0) {
                  delete layer1[i].children;
                }
              }

                // 存储机构树
              let structure = [];
              if(layer1.length > 0){
                structure = JSON.stringify(layer1);
              }else if(layer2.length > 0){
                structure = JSON.stringify(layer2);
              }else if(layer3.length > 0){
                structure = JSON.stringify(layer3);
              }else{
                structure = JSON.stringify(layer4);
              }

              localStorage.setItem("structure", structure);
            }
          } else {
            // 登录超时调用
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 跳转页面
    PageJump(command) {
      let index = command.split("/")[0];
      let i = command.split("/")[1];

      let txcode = this.institutionsTree[index].list[i].txcode;

      console.log(txcode);

      this.$router.push({
        name: txcode,
      });
    },

    // 在线状态统计图表
    onlineCharts(totalCount, onlineCount, offlineCount, lv) {
      //  销毁echarts实例
      this.echarts.dispose(document.getElementById("onlineCharts"));
      // 基于准备好的dom，初始化echarts实例
      var myChart = this.echarts.init(document.getElementById("onlineCharts"));

      let totalCounts = "设备总数：" + totalCount;
      let onlineCounts = "在线设备：" + onlineCount;
      let offlineCounts = "离线设备：" + offlineCount;
      // 指定图表的配置项和数据
      var option = {
        title: [
          {
            text: "设备在线状态统计",
            x: "center",
            y: "5px",
            textStyle: {
              fontSize: 18,
              fontWeight: "bolder",
              color: "#fff",
            },
          },
          {
            text: lv,
            x: "center",
            y: "40%",
            textStyle: {
              fontSize: 24,
              fontWeight: "bolder",
              color: "#fff",
            },
          },
          {
            text: "设备在线率",
            x: "center",
            y: "55%",
            textStyle: {
              fontSize: 14,
              fontWeight: "bolder",
              color: "#fff",
            },
          },
          {
            subtext: totalCounts,
            x: "6%",
            y: "85%",
            subtextStyle: {
              fontSize: 14,
              fontWeight: "bolder",
              color: "#fff",
            },
          },
          {
            subtext: onlineCounts,
            x: "36%",
            y: "85%",
            subtextStyle: {
              fontSize: 14,
              fontWeight: "bolder",
              color: "#fff",
            },
          },
          {
            subtext: offlineCounts,
            x: "66%",
            y: "85%",
            subtextStyle: {
              fontSize: 14,
              fontWeight: "bolder",
              color: "#fff",
            },
          },
        ],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          x: "left",
          y: "30px",
          textStyle: {
            color: "#fff",
          },
          data: ["在线", "离线"],
        },
        calculable: true,
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: ["50%", "65%"],
            label: {
              show: false,
            },
            data: [
              {
                value: onlineCount,
                name: "在线",
                itemStyle: {
                  color: "#73C0DE",
                },
              },
              {
                value: offlineCount,
                name: "离线",
                itemStyle: {
                  color: "#EE6666",
                },
              },
            ],
          },
        ],
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    // 设备报警统计图表
    policeCharts(highAlarm, lowAlarm) {
      //  销毁echarts实例
      this.echarts.dispose(document.getElementById("policeCharts"));
      // 基于准备好的dom，初始化echarts实例
      var myChart = this.echarts.init(document.getElementById("policeCharts"));

      // 指定图表的配置项和数据
      var option = {
        title: [
          {
            text: "设备报警统计",
            x: "center",
            y: "5px",
            textStyle: {
              fontSize: 18,
              fontWeight: "bolder",
              color: "#fff",
            },
          },
        ],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          x: "left",
          y: "30px",
          textStyle: {
            color: "#fff",
          },
          data: ["低报警", "高报警"],
        },
        calculable: true,
        series: [
          {
            // center: ["60%", "55%"],
            name: "访问来源",
            type: "pie",
            radius: ["50%", "65%"],
            label: {
              show: false,
            },
            data: [
              { value: highAlarm, name: "低报警" },
              { value: lowAlarm, name: "高报警" },
            ],
          },
        ],
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    // 报警状态统计图表
    callPoliceCharts(normalCount, warningCount) {
      //  销毁echarts实例
      this.echarts.dispose(document.getElementById("callPoliceCharts"));
      // 基于准备好的dom，初始化echarts实例
      var myChart = this.echarts.init(
        document.getElementById("callPoliceCharts")
      );
      let normalCounts = "正常设备：" + normalCount;
      let warningCounts = "报警设备：" + warningCount;

      // 指定图表的配置项和数据
      var option = {
        title: [
          {
            text: "报警状态统计",
            x: "center",
            y: "5px",
            textStyle: {
              fontSize: 18,
              fontWeight: "bolder",
              color: "#fff",
            },
          },
          {
            subtext: normalCounts,
            x: "25%",
            y: "85%",
            subtextStyle: {
              fontSize: 14,
              fontWeight: "bolder",
              color: "#fff",
            },
          },
          {
            subtext: warningCounts,
            x: "60%",
            y: "85%",
            subtextStyle: {
              fontSize: 14,
              fontWeight: "bolder",
              color: "#fff",
            },
          },
        ],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          x: "left",
          y: "30px",
          textStyle: {
            color: "#fff",
          },
          data: ["正常设备", "报警设备"],
        },
        calculable: true,
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: ["50%", "65%"],
            label: {
              show: false,
            },
            data: [
              {
                value: normalCount,
                name: "正常设备",
                itemStyle: {
                  color: "#C53433",
                },
              },
              {
                value: warningCount,
                name: "报警设备",
                itemStyle: {
                  color: "#2F4854",
                },
              },
            ],
          },
        ],
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    // 各分组报警统计
    groupingCharts() {
      //  销毁echarts实例
      this.echarts.dispose(document.getElementById("groupingCharts"));
      // 基于准备好的dom，初始化echarts实例
      var myChart = this.echarts.init(
        document.getElementById("groupingCharts")
      );

      var option = {
        textStyle: {
          color: "#fff",
        },
        title: {
          text: "各分组报警统计",
          x: "center",
          y: "5px",
          textStyle: {
            fontSize: 18,
            fontWeight: "bolder",
            color: "#fff",
          },
        },
        tooltip: {
          trigger: "axis",
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            boundaryGap: true,
            axisLabel: {
              show: true,
              interval: 0, //显示所有X轴信息
              rotate: 40, //倾斜角度
            },
            data: [
              "秦皇岛",
              "河北省",
              "禅城区",
              "西城区",
              "马厂",
              "东莞",
              "北京市",
              "石家庄",
              "顾义区",
              "中山",
            ],
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "报警总数",
            type: "bar",
            itemStyle: {
              color: "#C33531",
            },
            data: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0],
          },
        ],
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    // 报警类型统计
    typeCharts(policeList) {
      //  销毁echarts实例
      this.echarts.dispose(document.getElementById("typeCharts"));
      // 基于准备好的dom，初始化echarts实例
      var myChart = this.echarts.init(document.getElementById("typeCharts"));

      var option = {
        textStyle: {
          color: "#fff",
        },
        grid: {
          y2: 34,
        },
        title: {
          text: "报警类型统计",
          x: "center",
          textStyle: {
            fontSize: 18,
            fontWeight: "bolder",
            color: "#fff",
          },
        },
        legend: {
          y: "25px",
          textStyle: {
            color: "#fff",
          },
          data: ["正常", "高报警", "低报警"],
        },
        tooltip: {
          trigger: "axis",
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            boundaryGap: true,
            data: this.dateArray,
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "正常",
            type: "bar",
            data: policeList.normal,
          },
          {
            name: "高报警",
            type: "bar",
            data: policeList.lowAlarm,
          },
          {
            name: "低报警",
            type: "bar",
            data: policeList.highAlarm,
          },
        ],
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.index {
  position: fixed;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background: url("../assets/img/bj.jpg") no-repeat;
  background-size: 100% 100%;
}

.index_top {
  width: calc(100% - 20px);
  margin: 10px 10px 20px 10px;
  .index_Tleft {
    width: 30%;
    height: 50px;
    color: #fff;
    line-height: 50px;
    font-size: 22px;
    border-radius: 10px;
    background-color: rgba(12, 123, 171, 0.6);
    // background-color: #1c5453;
    span {
      height: 50px;
      // min-width: 40%;
      padding: 0 20px;
      box-sizing: border-box;
      img {
        height: 50px;
        &:hover {
          cursor: pointer;
        }
      }
    }
    .logo_img {
      width: 35%;
      min-width: 30%;
    }
    .logo_text {
      width: 65%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .index_Tright {
    width: 70%;
    height: 50px;
    // padding: 0 10px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;
    .index_text {
      color: #fff;
      text-shadow: #333 0 0 1px;
      height: 50px;
      line-height: 50px;
      font-size: 22px;
      padding: 0 15px;
      // margin: 0 10px;
      border-radius: 10px;
      cursor: pointer;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      // background-color: #1c5453;
      background-color: rgba(12, 123, 171, 0.6);
      &:hover {
        background-color: rgba(12, 143, 171, 0.6);
      }
    }
  }
}

.index_content {
  width: 100%;
  height: calc(100% - 80px);
  display: flex;
  justify-content: space-between;
  .index_content_list {
    width: 25%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 10px;
    .content_list_tab {
      width: 100%;
      height: calc(100% - 15px);
      margin-bottom: 15px;
      border-radius: 10px;
      overflow: hidden;
      box-sizing: border-box;
      border: 2px solid #81a7b5;
      .baoj {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 0 5px 5px 5px;
        overflow-y: auto;
        h1 {
          font-size: 18px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-weight: bold;
          color: #fff;
        }
        .baoj_title,
        .baoj_list {
          width: 100%;
          height: 30px;
          line-height: 30px;
          color: #fff;
          font-size: 12px;
          font-weight: bold;
          background-color: rgba(9, 139, 168, 0.6);
          span {
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            &:nth-child(1) {
              width: 20%;
            }
            &:nth-child(2) {
              width: 40%;
            }
            &:nth-child(3) {
              width: 40%;
            }
          }
        }
        .baoj_list {
          &:nth-child(2n-1) {
            background-color: transparent;
          }
        }
      }
    }
    .content_list {
      // background-color: #fff;
      width: 100%;
      height: calc(100% / 3 - 15px);
      margin-bottom: 15px;
      border-radius: 10px;
      box-sizing: border-box;
      border: 2px solid #81a7b5;
      .index_rbox_list {
        width: 100%;
        height: 100%;
      }
    }
  }
  .index_content_box {
    width: 50%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 10px;
    .content_top {
      width: 100%;
      height: calc(68% - 15px);
      margin-bottom: 15px;
      box-sizing: border-box;
      border: 2px solid #81a7b5;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .content_btn {
      width: 100%;
      height: calc(32% - 15px);
      margin-bottom: 15px;
      border-radius: 10px;
      box-sizing: border-box;
      border: 2px solid #81a7b5;
      // background-color: #fff;
      .index_rbox_list {
        width: 100%;
        height: 100%;
      }
    }
  }
}

// 更换LOGO/主图
.logo_box {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.5);
  .logo_content {
    width: 60%;
    height: 70%;
    position: absolute;
    left: 20%;
    top: 15%;
    background-color: #fff;
    .down {
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 999;
      i {
        color: #666;
        font-size: 20px;
        font-weight: bold;
        &:hover {
          color: #333;
          cursor: pointer;
        }
      }
    }
    /deep/ .el-tabs__nav-scroll {
      padding: 20px 0;
      box-sizing: border-box;
    }
    /deep/ .el-tabs__content {
      height: 100%;
      padding-right: 10px;
      box-sizing: border-box;
      h1 {
        height: 50px;
        line-height: 50px;
        color: #409eff;
        font-weight: bold;
        text-align: center;
        border-bottom: 2px solid #ddd;
      }
    }

    // 修改基本信息
    .user_box {
      position: absolute;
      width: calc(100% - 10px);
      height: calc(100% - 60px);
      overflow-y: auto;
      padding: 20px 40px;
      box-sizing: border-box;
      .box {
        display: flex;
      }
      .user_list {
        width: 50%;
        .user_box_list {
          margin: 15px 0;
          span {
            width: 150px;
            text-align: right;
            line-height: 40px;
          }
          p {
            text-indent: 15px;
            line-height: 40px;
          }
        }
      }

      .user_btn {
        width: 100%;
        text-align: center;
        margin: 20px auto;
        .el-button {
          padding: 14px 50px;
        }
      }

      .user_image {
        width: 100%;
        padding-left: 50px;
        box-sizing: border-box;
        h3 {
          color: red;
          margin: 5px 0;
        }
        h2 {
          margin: 20px 0 10px 0;
          font-size: 20px;
          color: #409eff;
        }
        .user_img1 {
          width: 100%;
          height: 100px;
          position: relative;
          .image1 {
            width: 100px;
            height: 100px;
            position: absolute;
            top: 0;
            left: 10px;
          }
          .input1 {
            width: 100px;
            height: 100px;
            position: absolute;
            top: 0;
            left: 10px;
            z-index: 99;
            opacity: 0;
          }
        }
        .user_img2 {
          width: 100%;
          // height: 100px;
          position: relative;
          .image2 {
            width: 400px;
            height: 250px;
            position: absolute;
            top: 0;
            left: 10px;
          }
          .input2 {
            width: 400px;
            height: 250px;
            position: absolute;
            top: 0;
            left: 10px;
            z-index: 99;
            opacity: 0;
          }
        }
      }
    }

    // 修改logo
    .logo_boxs {
      position: absolute;
      width: calc(100% - 10px);
      height: calc(100% - 150px);
      display: flex;
      justify-content: space-around;
      align-items: center;
      img {
        width: 200px;
        height: 200px;
        border-radius: 10px;
        border: 1px solid #ddd;
        box-sizing: border-box;
      }
      i {
        border-radius: 10px;
        width: 200px;
        height: 200px;
        line-height: 200px;
        font-size: 100px;
        text-align: center;
        color: #ccc;
        box-sizing: border-box;
        border: 1px solid #ddd;
        position: relative;
        input {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 10px;
          opacity: 0;
          z-index: 99;
          border: 2px solid rgb(245, 243, 243);
          &:hover {
            cursor: pointer;
          }
        }
      }
    }

    // 中心主图
    .deptPhoto {
      position: absolute;
      left: 20px;
      top: 80px;
      width: calc(100% - 50px);
      height: calc(100% - 150px);
      img {
        width: 100%;
        height: 100%;
      }
      input {
        position: absolute;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        z-index: 99;
        opacity: 0;
        background-color: #ccc;
      }
    }
    // 切换账号
    .switch_account {
      position: absolute;
      width: calc(100% - 10px);
      height: calc(100% - 60px);
      div {
        width: 100%;
        text-align: center;
        i {
          margin: 100px auto 0;
          width: 120px;
          height: 120px;
          line-height: 120px;
          font-size: 60px;
          color: #ccc;
          border-radius: 50%;
          border: 1px solid rgb(235, 233, 233);
        }
        p {
          margin: 10px 0;
        }
        .el-button {
          display: block;
          padding: 12px 50px;
          margin: 50px auto;
        }
      }
    }
    // 修改密码
    .password {
      width: 100%;
      .password_tab {
        padding-right: 150px;
        box-sizing: border-box;
        margin: 30px 20px;
        line-height: 40px;
        display: flex;
        justify-content: center;
        span {
          width: 150px;
          text-align: right;
        }
      }
      .password_text {
        color: red;
        text-align: center;
      }
      .password_btn {
        margin-top: 50px;
        display: flex;
        justify-content: center;
        .el-button {
          width: 200px;
        }
      }
    }
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>